import React from 'react';
import { BracketRoundContainer } from '../BracketRoundContainer';
import { GroupBracket } from '../GroupBracket';
import './style.scss';

export const MatchesMainContainer = ({ standings, brackets }) => {
  return (
    <div className="matches-view">
      <div className="matches-view__container">
        <div className="matches-view__container__groups">
          {standings?.map((standing, i) => (
            <GroupBracket
              key={`${standing.phase.id}${i}`}
              groupName={standing.phase.names.default}
              teams={standing.participants}
            />
          ))}
        </div>
        <div className="matches-view__container__brackets">
          {brackets?.map((round, i) => (
            <BracketRoundContainer
              round={round}
              key={`${round.phase.id}${i}`}
              position={`position-${i}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
